<div class="topbar">
  <div>
    <h1>Indstillinger for Serviceabonnement</h1>
  </div>
</div>
<div class="page__content settings">
  <div class="settings__wrap">
    @if (serviceabonnementer?.length == 0) {
      <div class="align-center">
        <p class="orange">
          <mat-icon svgIcon="obs-solid" class="icon-32"></mat-icon>
          <br />
          Ingen serviceabonnementer defineret
        </p>
      </div>
    }
    @if (serviceabonnementer?.length > 0) {
      <table mat-table [dataSource]="serviceabonnementer" class="mat-elevation-z0">
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>Beskrivelse</th>
          <td mat-cell *matCellDef="let row">
            {{ row.description }}
          </td>
        </ng-container>
        <ng-container matColumnDef="kundetype">
          <th mat-header-cell *matHeaderCellDef>Kundetype</th>
          <td mat-cell *matCellDef="let row">
            {{ row.kundeType.text }}
          </td>
        </ng-container>
        <ng-container matColumnDef="fakturaDescription">
          <th mat-header-cell *matHeaderCellDef>Faturatekst</th>
          <td mat-cell *matCellDef="let row">
            {{ row.fakturaDescription }}
          </td>
        </ng-container>
        <ng-container matColumnDef="okKundeVarenr">
          <th mat-header-cell *matHeaderCellDef>Varenummer</th>
          <td mat-cell *matCellDef="let row">
            {{ row.okKundeVarenr }}
          </td>
        </ng-container>
        <ng-container matColumnDef="opkraevningsinterval">
          <th mat-header-cell *matHeaderCellDef>Opkrævningsinterval</th>
          <td mat-cell *matCellDef="let row">
            {{ row.opkraevningInterval }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell class="row-actions" *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <div class="hidden-cell">
              <button (click)="edit(row)" class="btn-icon blue" aria-label="Rediger serviceabonnement" matTooltip="Rediger serviceabonnement">
                <mat-icon svgIcon="edit"></mat-icon>
              </button>
              @if (!row.isTilkaldsabonnement) {
                <button
                  (click)="relations(row)"
                  class="btn-icon blue"
                  aria-label="Administrer tilvalg"
                  matTooltip="Administrer tilvalg"
                  >
                  <mat-icon>swap_horiz</mat-icon>
                </button>
              }
              <button (click)="showhistory(row)" class="btn-icon blue" aria-label="Historik" matTooltip="Historik">
                <mat-icon>timeline</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    }
  </div>
</div>
<app-history-view [historyView]="historyView"></app-history-view>
